import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUser } from '../contexts/UserContext';
import Loading from './Loading';

const ProtectedRoute = ({ children, adminRequired = false }) => {
  const { userProfile, isAdmin, loading } = useUser();

  // Show loading while checking authentication
  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh'
      }}>
        <Loading />
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!userProfile) {
    return <Navigate to="/login" replace />;
  }

  // Redirect to search if admin required but user is not admin
  if (adminRequired && !isAdmin) {
    return <Navigate to="/search" replace />;
  }

  return children;
};

export default ProtectedRoute;
